<glxy-alert type="warning">
  <strong>{{ 'LIB_ORDERS.COMMON.ORDERS.ORDER_FORMS.HIDDEN_REQUIRED_FIELDS' | translate }}</strong>
  &mdash; {{ 'LIB_ORDERS.COMMON.ORDERS.ORDER_FORMS.HIDDEN_REQUIRED_FIELDS_DESCRIPTION' | translate }}
</glxy-alert>
